import { IconName } from 'src/components/Icon';
import { newExternalModelsList } from 'src/constants';
import { NINJA_AUTO_MODELS } from 'src/utils/llmResources';

export const getDefaultModelIconName = (modelId: string): IconName | null => {
  const provider = modelId.split('/')[0];

  switch (provider) {
    case 'bedrock':
      if (modelId.includes('nova-')) {
        return 'nova';
      }
      return 'awsLogo';

    case 'openai':
      return 'chatGPTLogo';

    case 'gemini':
      return 'googleGeminiProLogo';

    case 'ninja':
      return 'ninjaOutlined';

    default:
      return null;
  }
};

interface GetModelDisplayNameParams {
  targetModel?: string | null;
  defaultDisplayName?: string | null;
}

export const getModelDisplayName = ({
  targetModel,
  defaultDisplayName,
}: GetModelDisplayNameParams): string => {
  if (!!targetModel && NINJA_AUTO_MODELS.includes(targetModel)) {
    return 'Ninja Auto';
  }
  return (
    (!!targetModel &&
      (newExternalModelsList[targetModel]?.display_name ??
        defaultDisplayName)) ||
    defaultDisplayName ||
    ''
  );
};

interface GetModelIconParams {
  targetModel?: string | null;
  defaultIcon?: IconName;
}

export const getModelIcon = ({
  targetModel,
  defaultIcon,
}: GetModelIconParams): IconName | undefined => {
  if (!!targetModel && NINJA_AUTO_MODELS.includes(targetModel)) {
    return 'ninjaIcon';
  }
  return (
    (!!targetModel &&
      (newExternalModelsList[targetModel]?.icon_name ||
        getDefaultModelIconName(targetModel))) ||
    defaultIcon
  );
};
